const BASE_URL = process.env.VUE_APP_BASE_URL;

class User {
    constructor(id) {
        this.id = id
    }
}

export default {
    namespaced: true,
    state: {
        user: null,
        name: '',
        login: null,
        password: null,
    },
    mutations: {
        setUser(state, payload) {
            state.user = payload
            localStorage.setItem('user', payload)
            console.log('====== SET USER ======== ', state.user)
        },
        setName(state, payload) {
            state.name = payload
            localStorage.setItem('userName', payload)
        },
        setUserHeader(state, authKey) {
            //const Authorization = payload.headers.get('Authorization')
            console.log('payload', authKey);
            if (authKey) {
                localStorage.setItem('authKey', authKey)
                authKey = 'Bearer '+authKey;
                state.user = authKey
                localStorage.setItem('user', authKey)
                console.log('====== USER Header ======== ', state.user)
            }
        },
        setUserLogin(state, payload) {
            state.login = payload
        },
        setUserPassword(state, payload) {
            state.password = payload
        },
    },
    actions: {
        async loginUser({commit}, payload) {
            //commit('setLoading', true)
            return fetch(`${BASE_URL}login`,
                {
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Headers': '*',
                    },
                    method: 'POST',
                    body: JSON.stringify(payload)
                })
                .then(response => {
                    return response.json()
                })
                .then(
                    json => {
                        if (json.result) {
                            const {authKey, name} = json
                            commit('setUserHeader', authKey)
                            commit('setName', name)
                            commit('infoSnackbar/clearSnackbar', null, {root: true})
                            commit('infoSnackbar/setSnackbarMsg', 'Успешная авторизация', {root: true})
                            commit('infoSnackbar/setSnackbarType', 'success', {root: true})
                        } else {
                            commit('infoSnackbar/clearSnackbar', null,{root: true})
                            //commit('setSnackbarMsg', Object.values(json.message).join('; '))
                            commit('infoSnackbar/setSnackbarMsg', 'Ошибка авторизации', {root: true})
                            commit('infoSnackbar/setSnackbarType', 'error', {root: true})
                        }
                        //commit('setLoading', false)
                        return json.result
                    }
                )
                .catch(
                    error => {
                        console.error(error)
                        commit('infoSnackbar/clearSnackbar',null, {root: true})
                        commit('infoSnackbar/setSnackbarMsg', 'Ошибка авторизации', {root: true})
                        commit('infoSnackbar/setSnackbarType', 'error', {root: true})
                    }
                )
        },
        async loginByCodeUser({commit}, payload) {
            //commit('setLoading', true)
            return fetch(`${BASE_URL}login-by-code`,
                {
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Headers': '*',
                    },
                    method: 'POST',
                    body: JSON.stringify(payload)
                })
                .then(response => {
                    return response.json()
                })
                .then(
                    json => {
                        if (json.result) {
                            const {authKey, name} = json
                            commit('setUserHeader', authKey)
                            commit('setName', name)
                            commit('infoSnackbar/clearSnackbar', null, {root: true})
                            commit('infoSnackbar/setSnackbarMsg', 'Успешная авторизация', {root: true})
                            commit('infoSnackbar/setSnackbarType', 'success', {root: true})
                        } else {
                            commit('infoSnackbar/clearSnackbar', null,{root: true})
                            //commit('setSnackbarMsg', Object.values(json.message).join('; '))
                            commit('infoSnackbar/setSnackbarMsg', 'Ошибка авторизации', {root: true})
                            commit('infoSnackbar/setSnackbarType', 'error', {root: true})
                        }
                        //commit('setLoading', false)
                        return json.result
                    }
                )
                .catch(
                    error => {
                        console.error(error)
                        commit('infoSnackbar/clearSnackbar',null, {root: true})
                        commit('infoSnackbar/setSnackbarMsg', 'Ошибка авторизации', {root: true})
                        commit('infoSnackbar/setSnackbarType', 'error', {root: true})
                    }
                )
        },
        autoLoginUser({commit}, payload) {
            commit('setUser', payload)
            localStorage.setItem('user', payload)
        },
        autoUserName({commit}, payload) {
            commit('setName', payload)
            localStorage.setItem('userName', payload)
        },
        async logoutUser({commit, getters}, payload) {
            commit('setUser', null)
            localStorage.removeItem('user')
        },
        async sendCode({commit}, payload) {
            return fetch(`${BASE_URL}send-code`,
                {
                    mode: 'cors',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Headers': '*',
                    },
                    method: 'POST',
                    body: JSON.stringify(payload)
                })
                .then(response => {
                    return response.json()
                })
                .then(
                    json => {
                        if (json.result) {
                            commit('infoSnackbar/clearSnackbar', null, {root: true})
                            commit('infoSnackbar/setSnackbarMsg', 'Ждите звонка', {root: true})
                            commit('infoSnackbar/setSnackbarType', 'success', {root: true})
                        } else {
                            let message = 'Ошибка: ';
                            console.log(json);
                            if(Array.isArray(json)){
                                json.forEach(item => {
                                    console.log(item);
                                   if(item.message){
                                       message += item.message + '; ';
                                   }
                                });
                            }
                            commit('infoSnackbar/clearSnackbar', null,{root: true})
                            commit('infoSnackbar/setSnackbarMsg', 'Ошибка', {root: true})
                            commit('infoSnackbar/setSnackbarType', 'error', {root: true})
                        }
                        //commit('setLoading', false)
                        return json.result
                    }
                )
                .catch(
                    error => {
                        console.error(error)
                        commit('infoSnackbar/clearSnackbar',null, {root: true})
                        commit('infoSnackbar/setSnackbarMsg', 'Неизвестная ошибка', {root: true})
                        commit('infoSnackbar/setSnackbarType', 'error', {root: true})
                    }
                )
        }
    },
    getters: {
        user(state) {
            return state.user
        },
        name(state) {
            return state.name
        },
        isUserLoggedIn(state) {
            return state.user !== null
        },
        login(state) {
            return state.login
        },
        password(state) {
            return state.password
        },
    }
}
